<template>
  <div class="box" :class="{ dense }">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  dense?: boolean;
}>();
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid #d3d3d3;
  border-radius: var(--border-r-sm);
  box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.04) !important;
  padding: var(--space-5);
  background-color: white;

  &.dense {
    padding: var(--space-3);
  }
}

@media (max-width: 850px) {
  .box {
    padding: var(--space-3);
  }
}
</style>